'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('../resource'),
    PersonResource = _require2.PersonResource;

module.exports.Person = function (_BaseEntity) {
  _inherits(Person, _BaseEntity);

  _createClass(Person, null, [{
    key: '__name__',
    value: function __name__() {
      return 'person';
    }
  }]);

  function Person(data) {
    _classCallCheck(this, Person);

    var _this = _possibleConstructorReturn(this, (Person.__proto__ || Object.getPrototypeOf(Person)).call(this));

    _this._entityName = 'de.ul.fob.domain.Person';
    _this.name = null;
    _this.titel = null;
    _this.vorname = null;
    _this.fisPersid = null;

    _this.organisationseinheiten = null;
    _this.personIdent = null;
    _get(Person.prototype.__proto__ || Object.getPrototypeOf(Person.prototype), 'init', _this).call(_this, data);

    var extraKeys = ['orcidId', 'researcherId'];

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = extraKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        if (key in data) {
          _this[key] = data[key];
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return _this;
  }

  _createClass(Person, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'name', 'titel', 'vorname', 'fisPersid'],
        links: ['organisationseinheiten', 'personIdent']
      });
    }
  }, {
    key: 'fetchOrganisationseinheiten',
    value: function fetchOrganisationseinheiten() {
      return _get(Person.prototype.__proto__ || Object.getPrototypeOf(Person.prototype), 'genericResolve', this).call(this, 'organisationseinheiten');
    }
  }, {
    key: 'fetchPersonIdent',
    value: function fetchPersonIdent() {
      return _get(Person.prototype.__proto__ || Object.getPrototypeOf(Person.prototype), 'genericResolve', this).call(this, 'personIdent');
    }
  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(Person.prototype.__proto__ || Object.getPrototypeOf(Person.prototype), 'genericResolve', this).call(this, 'organisationseinheiten'), _get(Person.prototype.__proto__ || Object.getPrototypeOf(Person.prototype), 'genericResolve', this).call(this, 'personIdent')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof PersonResource === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(Person.prototype.__proto__ || Object.getPrototypeOf(Person.prototype), 'fetchQuery', this).call(this, PersonResource);
      }
    }
  }]);

  return Person;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/person.js
// module id = g15J
// module chunks = 0